import { render, staticRenderFns } from "./quiz-layout.vue?vue&type=template&id=161b7255&scoped=true&"
import script from "./quiz-layout.vue?vue&type=script&lang=js&"
export * from "./quiz-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b7255",
  null
  
)

export default component.exports